package com.hyperether.goodjob.scenes.contacts.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material.Divider
import androidx.compose.material.Icon
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.Sp
import com.hyperether.resources.stringResource
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.navigation.*
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.contacts_mail
import com.hyperether.goodjob.resources.contacts_map_pin
import com.hyperether.goodjob.resources.contacts_share
import com.hyperether.goodjob.resources.phone_1
import com.hyperether.goodjob.resources.sites
import com.hyperether.goodjob.scenes.components.RoundedCornerCheckbox
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.ContactDetailsText
import org.jetbrains.compose.resources.painterResource


@Composable
fun ContactsList(
    contacts: List<Contact>,
    contactSites: List<Site>,
    selectedContacts: MutableList<Contact>,
    isInEditMode: Boolean,
    navHostController: NavHostController
) {

    LazyColumn(
        modifier = Modifier.fillMaxSize()
    ) {
        items(contacts) { contact ->
            ContactsItem(
                contact = contact,
                isSelected = selectedContacts.contains(contact),
                isInEditMode = isInEditMode,
                onContactSelected = {
                    if (selectedContacts.contains(contact)) {
                        selectedContacts.remove(contact)
                    } else {
                        selectedContacts.add(contact)
                    }
                },
                onItemClick = {
                    contact.id?.let { navHostController.navigate(ContactDetails(it)) }
                },
                sites = contactSites.filter { it.parentId == contact.id }
            )
            Divider(
                //modifier = Modifier.padding(),
                color = Color.Gray,
                thickness = Dp(0.5f)
            )
        }
    }
}

@Composable
fun ContactsItem(
    contact: Contact,
    isSelected: Boolean,
    sites: List<Site>,
    isInEditMode: Boolean,
    onContactSelected: () -> Unit,
    onItemClick: () -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(Dp(16f))
            .clickable {
                if (isInEditMode) {
                    onContactSelected()
                } else {
                    onItemClick()
                }
            }
    ) {
        if (isInEditMode) {
            RoundedCornerCheckbox(
                isChecked = isSelected,
                onCheckedChange = { _ ->
                    onContactSelected()
                }
            )
        }

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(start = Dp(8f))
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = Dp(4f)),
                verticalAlignment = Alignment.CenterVertically
            ) {
                contact.name?.let {
                    Text(
                        text = it,
                        fontSize = Sp(16f),
                        color = BlueApp,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        fontWeight = FontWeight.Bold,
                        modifier = Modifier.weight(2f)
                    )
                }
                Spacer(modifier = Modifier.width(Dp(15f)))
                contact.personName?.let {
                    Text(
                        text = it,
                        fontSize = Sp(14f),
                        color = Color.Gray,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier.weight(1f)
                    )
                }
            }

            Spacer(modifier = Modifier.height(Dp(4f)))

            if (contact.email?.isNotEmpty() == true) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.contacts_mail),
                        contentDescription = null,
                        modifier = Modifier.size(Dp(20f)),
                        tint = Color.Gray
                    )
                    Spacer(modifier = Modifier.width(Dp(8f)))
                    Text(
                        text = contact.email ?: "",
                        fontSize = Sp(14f),
                        color = ContactDetailsText
                    )
                }
                Spacer(modifier = Modifier.height(Dp(4f)))
            }

            if (contact.addressObject?.address?.isNotEmpty() == true) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.contacts_map_pin),
                        contentDescription = null,
                        modifier = Modifier.size(Dp(20f)),
                        tint = Color.Gray
                    )
                    Spacer(modifier = Modifier.width(Dp(8f)))
                    contact.addressObject?.address?.let {
                        Text(
                            text = it,
                            fontSize = Sp(14f),
                            color = ContactDetailsText
                        )
                    }
                }
                Spacer(modifier = Modifier.height(Dp(4f)))
            }

            if (contact.phone?.isNotEmpty() == true) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.phone_1),
                        contentDescription = null,
                        modifier = Modifier.size(Dp(20f)),
                        tint = Color.Gray
                    )
                    Spacer(modifier = Modifier.width(Dp(8f)))
                    contact.phone?.let {
                        Text(
                            text = it,
                            fontSize = Sp(14f),
                            color = ContactDetailsText
                        )
                    }
                }
                Spacer(modifier = Modifier.height(Dp(4f)))
            }

            if (contact.industry?.isNotEmpty() == true) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.contacts_share),
                        contentDescription = null,
                        modifier = Modifier.size(Dp(20f)),
                        tint = Color.Gray
                    )
                    Spacer(modifier = Modifier.width(Dp(8f)))
                    contact.industry?.let {
                        Text(
                            text = it,
                            fontSize = Sp(14f),
                            color = ContactDetailsText
                        )
                    }
                }
                Spacer(modifier = Modifier.height(Dp(4f)))
            }

            Text(
                text = sites.size.toString() + " " + stringResource(Res.string.sites).lowercase(),
                fontSize = Sp(14f),
                color = BlueApp
            )
        }
    }
}

